import { CashSessionStatus } from '@/@types/cash-management';
import { Chip } from '@mui/material';

const statusLabel: Record<CashSessionStatus, string> = {
  OPEN: 'Aberto',
  RECONCILIATION: 'Em conferência',
  CLOSED: 'Fechado',
};

const statusColor: Record<
  CashSessionStatus,
  'success' | 'warning' | 'primary'
> = {
  OPEN: 'success',
  RECONCILIATION: 'warning',
  CLOSED: 'primary',
};

type CashSessionStatusLabelProps = {
  status: CashSessionStatus;
};

export function CashSessionStatusLabel({
  status,
}: CashSessionStatusLabelProps) {
  return <Chip color={statusColor[status]} label={statusLabel[status]} />;
}

export {
  statusLabel as cashSessionStatusLabel,
  statusColor as cashSessionStatusColor,
};
